import React from 'react';
import { HighscoreItemList } from './quiztypes';
import BizPhrase from '../../Components/Phrase';
import { useGetHighscore } from './Hooks/useQuiz';
import BizAvatar from '../../../Js/React/UI/BizAvatar/BizAvatar';

type HighscoreProps = {
	pluginInstanceId?: number;
	highscoreList?: HighscoreItemList;
	max?: number;
};

const defaultMax = 10;

const Highscore = ({ pluginInstanceId, highscoreList: providedHighscoreList, max }: HighscoreProps) => {
	const highscoreListViaPluginInstanceId = useGetHighscore(pluginInstanceId, max ?? defaultMax);

	const getHighscoreList = (): HighscoreItemList | undefined => {
		if (providedHighscoreList) {
			return {
				...providedHighscoreList,
				ScoreItems: providedHighscoreList.ScoreItems.slice(0, max ?? defaultMax),
			};
		} else {
			return highscoreListViaPluginInstanceId;
		}
	};

	const highscoreList = getHighscoreList();

	return (
		<div className='quiz-highscore'>
			<div className='highscore-top'>
				<span>{highscoreList?.QuizName ?? <BizPhrase phraseKey='SPEEDQUIZ.TOPLIST'></BizPhrase>}</span>
			</div>
			<div className='highscore-list'>
				<div className='highscore-list-header'>
					<span>
						<BizPhrase phraseKey='SPEEDQUIZ.HIGHSCORELIST.RANK'></BizPhrase>
					</span>
					<span className='highscore-item-alias'>
						<BizPhrase phraseKey='SPEEDQUIZ.HIGHSCORELIST.NAME'></BizPhrase>
					</span>
					<span>
						<BizPhrase phraseKey='SPEEDQUIZ.HIGHSCORELIST.POINTS'></BizPhrase>
					</span>
				</div>
				{highscoreList?.ScoreItems !== undefined &&
					highscoreList.ScoreItems.map((hi, index) => (
						<div key={index} className='highscore-item'>
							<span>{index + 1}</span>
							<BizAvatar photo={hi.UserPhoto} name={hi.Alias} />
							<span className='highscore-item-alias'>{hi.Alias}</span>
							<span>{hi.Score.toLocaleString()}</span>
						</div>
					))}
				{highscoreList?.ScoreItems.length === 0 && (
					<div className='highscore-item no-data'>
						<BizPhrase phraseKey='SPEEDQUIZ.HIGHSCORELIST.NO_RESULTS'></BizPhrase>
					</div>
				)}
			</div>
		</div>
	);
};

export default Highscore;
